// Vendor imports
const React = require('react')
// Client V2 common imports
const { CheckExperiment } = require('client-v2/common/containers/rollouts')
// Sibling imports
const TopCallToActionSplitTrailingCarousel = require('./split-trailing-carousel')
const TopCallToActionSplitTrailingList = require('./split-trailing-list-smart')
// Convenience; in lieu of JSX transpiling...
const { createElement: tag } = React

function TopCallToActionSplitTrailing(props) {
  return tag(CheckExperiment, {
    experimentKey: '*logged_out_top_cta',
    renderWithModifier: modifier => {
      if (modifier === 'c') {
        return tag(TopCallToActionSplitTrailingCarousel, props)
      }
      return tag(TopCallToActionSplitTrailingList, props)
    }
  })
}

module.exports = TopCallToActionSplitTrailing
